import { all, call, fork, put, take, takeEvery } from 'redux-saga/effects';
import {
  ManagerAccountApi,
  ManagerAccountControllerDtoLoginRequest,
  ManagerAccountControllerDtoLoginTwoFaAuthRequest,
} from '../models/src';
import { firebaseAuth, firebaseDb } from '../../firebase';
import history from '../../utils/history';
import {
  LOGIN_INFO,
  LOGIN_REQUEST,
  LOGIN_TWOFA_AUTH,
  LOGIN_WITH_EMAIL_REQUEST,
  LOGOUT_REQUEST,
  PASSWORD_FORGET_REQUEST,
  REGISTER_WITH_EMAIL_SUCCESS,
} from '../constants/authConstants';
import {
  createUserFailure,
  createUserSuccess,
  loginFailure,
  loginSuccess,
  loginTwofaAuthSuccess,
  loginTwoFaAuthFailure,
  loginWithEmailFailure,
  loginWithEmailSuccess,
  logoutFailure,
  logoutSuccess,
  passwordForgetFailure,
  passwordForgetSuccess,
  syncUser,
} from '../actions/authActions';
import config from '../../config/config';
import BaseResponse from '../models/src/model/BaseResponse';
import LoginInfoRes from '../models/src/model/LoginInfoRes';
import CategoryListRes from '../models/src/model/CategoryListRes';
import cookies from 'react-cookies';
import { createNotificationTokenRequest } from '../actions/notification/notificationActions';
import pwdHashAPI from '../../api/ui/pwdHashAPI';
import PaginationOptions from '../../api/ui/paginationOptions';
import ManagerAccountControllerDtoLoginResponse from '../models/src/model/ManagerAccountControllerDtoLoginResponse';
import ManagerAccountControllerDtoLoginTwoFaAuthResponse
  from '../models/src/model/ManagerAccountControllerDtoLoginTwoFaAuthResponse';
import ManagerAccountControllerDtoLoginInfoResponse
  from '../models/src/model/ManagerAccountControllerDtoLoginInfoResponse';
// import LocalizationManager from '../../api/ui/localization-manager';

const api = new ManagerAccountApi(config.API_CLIENT);
function convertToMenu(category) {
  const menulist = [];
  category.forEach((item) => {
    const menu = {};
    menu.key = item.key;
    menu.name = item.name;
    menu.multilevel = true;
    menu.icon = item.icon;
    menu.readonly = item.readonly;
    const lnblist = [];
    if (item.lnbList !== undefined && item.lnbList.length > 0) {
      item.lnbList.forEach((lnb) => {
        // console.log(lnb);
        const lnbMenu = {};
        lnbMenu.key = lnb.key;
        lnbMenu.name = lnb.name;
        lnbMenu.readonly = lnb.readonly;
        const sublist = [];
        if (lnb.subList !== undefined && lnb.subList.length > 0) {
          lnb.subList.forEach((sub) => {
            // console.log(sub);
            const subMenu = {};
            subMenu.key = sub.key;
            subMenu.name = sub.name;
            subMenu.link = sub.pageUrl;
            subMenu.readonly = sub.readonly;
            sublist.push(subMenu);
          });
          lnbMenu.keyParent = item.key;
          lnbMenu.child = sublist;
        } else {
          lnbMenu.link = lnb.pageUrl;
        }
        lnblist.push(lnbMenu);
      });
      menu.child = lnblist;
    } else {
      menu.link = item.pageUrl;
    }
    menu.data = item;
    menulist.push(menu);
  });
  return menulist;
}
// TODO: 아래 함수 동작 확인 필요
function getUrlVars() {
  const vars = {};
  // eslint-disable-next-line no-unused-vars
  const parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      },
  );
  return vars;
}

function* loginSaga(provider) {
  try {
    const data = yield call(
        firebaseAuth.signInWithPopup,
        provider.payload.authProvider,
    );
    yield put(loginSuccess(data));
    if (getUrlVars().next) {
      // Redirect to next route
      history.push(getUrlVars().next);
    } else {
      // Redirect to Dashboard if no next parameter
      history.push('/admin');
    }
  } catch (error) {
    yield put(loginFailure(error));
  }
}

function checkLoginCode(code) {
  let result = '';
  switch (code) {
    case '403.6':
      // - 아이피 차단
      result = '차단된 아이피입니다.';
      break;
    case '417.1':
      // - 계정정보 없음
      result = '계정 정보가 존재하지 않습니다.';
      break;
    case '417.2':
      // - 비밀번호 다름
      result = '비밀번호가 잘못되었습니다.';
      break;
    case '417.3':
      // - 탈퇴 계정
      result = '탈퇴처리된 계정입니다.';
      break;
    case '419.1':
      // - 계정 비활성화 상태
      result = '비활성화된 계정입니다.';
      break;
    case '419.2':
      // - 이미 접속중인 계정
      result = '이미 접속중인 계정입니다.';
      break;
    default:
      result = code;
      break;
  }
  return result;
}

function* loginWithEmailSaga(payload) {
  console.log("loginWithEmailSaga");
  try {
    const requestData = new ManagerAccountControllerDtoLoginRequest();
    requestData.email = payload.email;
    requestData.password = pwdHashAPI.toSha512(payload.password);
    const result = yield api.apiManagerAccountLoginPost(
        { managerAccountControllerDtoLoginRequest: requestData },
        () => {},
    );
    const data = api.apiClient.deserialize(
        result,
        ManagerAccountControllerDtoLoginResponse,
    );

    console.log("data");
    console.log(data);

    switch (data.resultCode) {
      case 200:
        yield put(loginWithEmailSuccess(data));
        if (data.twofaImage) {
          // 2차 인증 등록 페이지 TwoFAQrcode
          history.push('/twoFAQrcode', data);
        } else {
          // 인증 페이지 TwoFANum
          history.push('/twoFANum', data);
        }
        break;
      default:
        console.error(data.description);
        yield put(
            loginWithEmailFailure({
              message: `${checkLoginCode(data.code)}`,
            }),
        );
        break;
    }
  } catch (error) {
    yield put(loginWithEmailFailure(error));
  }
}

function* loginTowfaAuth(payload) {
  try {
    const result = yield api.apiManagerAccountLoginTwofaAuthPost(
        {
          managerAccountControllerDtoLoginTwoFaAuthRequest:
              new ManagerAccountControllerDtoLoginTwoFaAuthRequest(
                  payload.twofaAuthCode,
                  payload.twofaNo,
              ),
        },
        () => {},
    );
    const data = api.apiClient.deserialize(
        result,
        ManagerAccountControllerDtoLoginTwoFaAuthResponse,
    );

    console.log("data");
    console.log(data);
    if (data.resultCode === 200) {
      // api.apiClient.defaultHeaders = { AccessToken: data.accessToken };
      api.apiClient.defaultHeaders.AccessToken = data.accessToken;
      sessionStorage.setItem('token', data.accessToken);
      cookies.save('token', data.accessToken, {
        path: '/', // 쿠키 값을 저장하는 서버 경로
      });

      const userInfoResult = yield api.apiManagerAccountLoginInfoPost(() => {});
      const userInfo = api.apiClient.deserialize(userInfoResult, LoginInfoRes);
      const menuResult = yield api.apiManagerAccountCategoryListPost(() => {});
      const menuData = api.apiClient.deserialize(menuResult, CategoryListRes);
      const menulist = yield convertToMenu(menuData.categoryList);
      userInfo.menu = menulist;
      const fcmToken = cookies.load('fcmToken');
      if (fcmToken !== undefined) {
        yield put(createNotificationTokenRequest(userInfo.managerNo, fcmToken));
      }

      // 페이지 목록 Config 캐싱
      yield PaginationOptions.getInstance();

      // 로컬라이제이션 매니저 초기화, 스트링 테이블을 캐싱한다.
      // const lm = LocalizationManager.getInstance();
      // yield lm.initialize();
      // TODO: 아래는 테스트용, 필요 없게 되면 주석 처리할 것
      // console.log(`스트링 테이블 테스트: ${'TEST_MESSAGE_WELCOME'.locale()}`);
      // console.log(
      //   `스트링 테이블 테스트: ${'TEST_MESSAGE_WELCOME_YOU'.pluralLocale({
      //     Param1: '데이비드',
      //   })}`,
      // );
      // console.log(
      //   `우편 스트링 테스트: ${'TEST_POST_VALUE_STRING_01||{10,HELLO,안녕}'.locale()}`,
      // );
      // console.log(
      //   `우편 스트링 테스트: ${'TEST_POST_VALUE_STRING_02||{남,한국}'.pluralLocale(
      //     {
      //       Param1: '성별',
      //       Param2: '국적',
      //     },
      //   )}`,
      // );
      yield put(syncUser(userInfo));
      yield put(loginTwofaAuthSuccess('Success'));
    }else if (data.resultCode === 408) {
      yield put(loginTwoFaAuthFailure('인증 시간이 만료되었습니다.' ));
    } else if (data.resultCode === 406){
      yield put(loginTwoFaAuthFailure('인증 번호가 올바르지 않습니다.' ));
    }
  } catch (error) {
    console.error(error);
    yield put(loginTwoFaAuthFailure('오류가 발생했습니다.' ));
  }
}

function* loginInfo(payload) {
  try {
    api.apiClient.defaultHeaders.AccessToken = payload.accessToken;
    sessionStorage.setItem('token', payload.accessToken);
    cookies.save('token', payload.accessToken, {
      path: '/', // 쿠키 값을 저장하는 서버 경로
    });
    const userInfoResult = yield api.apiManagerAccountLoginInfoPost(() => {});
    const userInfo = api.apiClient.deserialize(userInfoResult, ManagerAccountControllerDtoLoginInfoResponse);

    const menuResult = yield api.apiManagerAccountCategoryListPost(() => {});
    const menuData = api.apiClient.deserialize(menuResult, CategoryListRes);
    userInfo.menu = yield convertToMenu(menuData.categoryList);

    yield put(syncUser(userInfo));

    if (userInfo?.resultCode !== 200) {
      cookies?.remove('token', { path: '/' });
      window.location.assign('/');
    }
  } catch (error) {
    yield put(loginWithEmailFailure(error));
    cookies?.remove('token', { path: '/' });
    window.location.assign('/');
  }
}

// function* registerWithEmailSaga(payload) {
//   try {
//     yield call(firebaseAuth.createUserWithEmailAndPassword, payload.email, payload.password);
//     const dataWithName = yield call(firebaseAuth.updateProfile, {
//       displayName: payload.name,
//     });
//     yield put(registerWithEmailSuccess(dataWithName));
//     // Redirect to Dashboard
//     history.push('/admin');
//   } catch (error) {
//     yield put(registerWithEmailFailure(error));
//   }
// }

function* logoutSaga() {
  try {
    const result = yield api.apiManagerAccountLogoutPost(() => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    yield put(logoutSuccess(data));
    // sessionStorage.removeItem('token');
    cookies.remove('token', { path: '/' });
    history.push('/');
  } catch (error) {
    yield put(logoutFailure(error));
  }
}

function* syncUserSaga() {
  const channel = yield call(firebaseAuth.channel);
  while (true) {
    const { user } = yield take(channel);
    if (user) {
      yield put(syncUser(user));
    } else {
      yield put(syncUser(null));
    }
  }
}

function* createUserSaga({ credential }) {
  try {
    yield call(firebaseDb.create, 'user', {
      email: credential.email,
      displayName: credential.displayName,
      creationTime: credential.metadata.creationTime,
    });
    yield put(createUserSuccess(credential));
  } catch (error) {
    yield put(createUserFailure(error));
  }
}

function* passwordForgetSaga({ email }) {
  try {
    yield call(firebaseAuth.sendPasswordResetEmail, email);
    yield put(passwordForgetSuccess());
  } catch (error) {
    yield put(passwordForgetFailure(error));
  }
}

//= ====================================
//  WATCHERS
//-------------------------------------

function* loginRootSaga() {
  yield fork(syncUserSaga);
  yield all([
    takeEvery(LOGIN_REQUEST, loginSaga),
    takeEvery(LOGIN_WITH_EMAIL_REQUEST, loginWithEmailSaga),
    takeEvery(LOGIN_TWOFA_AUTH, loginTowfaAuth),
    // takeEvery(REGISTER_WITH_EMAIL_REQUEST, registerWithEmailSaga),
    takeEvery(REGISTER_WITH_EMAIL_SUCCESS, createUserSaga),
    takeEvery(LOGOUT_REQUEST, logoutSaga),
    takeEvery(PASSWORD_FORGET_REQUEST, passwordForgetSaga),
    takeEvery(LOGIN_INFO, loginInfo),
  ]);
}

const authSagas = [fork(loginRootSaga)];

export default authSagas;
